import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Journey from "./pages/Journey";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/journey" element={<Journey />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
            <Footer />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
